var spoiler_default = {
  "fontElementMap": "jKdg9",
  "hideText": "qrSVq",
  "onHoverText": "Vxar0",
  "hideBlock": "ICi9X",
  "smallBlur": "_1jnNf",
  "mediumBlur": "NQqaj",
  "largeBlur": "H5bzh",
  "hideBlock_gallery": "_9b9YR",
  "overlay": "_4F7IJ",
  "overlay_gallery": "_0w1N1",
  "revealSpoilerBtn": "PhsAo",
  "isMobile": "-dFwk",
  "onHoverBtn": "dp0N-",
  "spoilerWrapper": "ZPI1-",
  "spoilerDescription": "ak9dC",
  "spoilerContainer": "ytXbb",
  "spoilerContainer_Gallery": "xYZmD"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
